var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96305 11.9135C6.77316 12.0887 6.46528 12.0887 6.27538 11.9135L0.44035 6.52727C0.250457 6.35199 0.250457 6.06779 0.44035 5.8925L6.27538 0.506318C6.46528 0.331032 6.77316 0.331032 6.96305 0.506318C7.15294 0.681605 7.15294 0.9658 6.96305 1.14109L1.47185 6.20989L6.96305 11.2787C7.15294 11.454 7.15294 11.7382 6.96305 11.9135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/WhiteArrow.60606b983a308342b6dcc0bd69e37119.svg";
export { ForwardRef as ReactComponent };